import { gql } from "@apollo/client";

import { CONFIG_ELEMENT_FRAGMENT } from "components/Environment/gql";

export const GET_ENVIRONMENT = gql`
  query GetEnvironment($stackId: ID!) {
    stack(id: $stackId) {
      id
      attachedContexts {
        id
        contextDescription
        contextId
        contextLabels
        contextName
        isAutoattached
        priority
        config {
          ...configElement
        }
      }
      canWrite
      name
      runtimeConfig {
        context {
          contextId
          contextName
        }
        element {
          ...configElement
        }
        stackDependency {
          id
          dependsOnStack {
            id
            name
          }
        }
      }
      trackedCommit {
        url
        hash
      }
      trackedBranchHead {
        url
        hash
      }
      trackedCommitSetBy
    }
  }
  ${CONFIG_ELEMENT_FRAGMENT}
`;
